import { Dispatcher } from 'flux';
import utils from "./Util";

var __dispatch = new Dispatcher();

var handleDispatch = function handleDispatch(_ref) {
  var eventName = _ref.eventName,
      eventData = _ref.eventData;
  utils.debug("v2/index:handleDispatch");
  var atLeastDispatchOneEvent = false;
  allEvents.forEach(function (event) {
    if (event.name === eventName) {
      event.notify(eventData);
      atLeastDispatchOneEvent = true;
    }
  });
  if (!atLeastDispatchOneEvent) throw new Error("No event: ".concat(eventName, " exists in the System"));
};

__dispatch.register(handleDispatch);
/**
 * Dispatches an event to the Dispatching system
 * @param eventName The Name of the Event
 * @param eventData The data to be passed
 */


var dispatchEvent = function dispatchEvent(eventName, eventData) {
  utils.debug("v2/index:dispatchEvent");
  utils.validateText(eventName);

  __dispatch.dispatch({
    eventName: eventName,
    eventData: eventData
  });
};

var allEvents = new Array();
export { allEvents, dispatchEvent };